import type { HTMLAttributes as SvelteHtmlAttrs } from 'svelte/elements';

declare global {
    interface HTMLElementTagNameMap {
        /**
 *
 */
        'ofc-pricing-item-v1': HTMLElement & PricingItemV1Props;
    }

    namespace svelteHTML {
        interface IntrinsicElements {
            /**
 *
 */
            'ofc-pricing-item-v1': PricingItemV1Props & SvelteHtmlAttrs<HTMLElementTagNameMap['ofc-pricing-item-v1']>;
        }
    }
}

/**
 *
 */
export { PRICING_ITEM_V1_TAG } from './PricingItemV1.constants.js';

/**
 *
 */
export enum DisplayAlignment {
    Left = 'left',
    Right = 'right',
}

/**
 *
 *
 *
 *
 */
export const DisplaySize = {
    '100': '100',
    '200': '200',
} as const;
export type DisplaySize = (typeof DisplaySize)[keyof typeof DisplaySize];

/**
 *
 */
export type PricingItemV1Props = {
    /**
 *
 *
 *
 *
 *
 */
    retailPrice: number;

    /**
 *
 *
 *
 */
    benefitPrice?: number;

    /**
 *
 *
 *
 */
    benefitUnitPrice?: number;

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    dealHighlight?: string;

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    dealId?: string;

    /**
 *
 *
 *
 *
 */
    displayAlignment?: DisplayAlignment;

    /**
 *
 *
 *
 *
 */
    displaySize?: DisplaySize;

    /**
 *
 *
 *
 */
    isStartingPrice?: boolean;

    /**
 *
 *
 *
 *
 */
    metaOriginFeature?: string;

    /**
 *
 *
 *
 */
    metaTeam?: string;

    /**
 *
 *
 *
 *
 *
 */
    oldPrice?: number;

    /**
 *
 *
 *
 *
 *
 */
    suggestedRetailPrice?: number;

    /**
 *
 *
 *
 *
 *
 */
    unitPrice?: number;

    /**
 *
 *
 *
 *
 *
 */
    unitPriceAmount?: number;

    /**
 *
 *
 *
 *
 *
 */
    unitPriceUnit?: string;
};
